import { IUser } from '@alberta/konexi-shared';

import { AggregateRoot } from '../aggregate-root';

export class UserDto extends AggregateRoot implements IUser {
  accountingType: 'full' | 'light' | 'doNotBill';
  postalCode: string;
  city: string;
  active: boolean;
  fax: string;
  organization: string;
  groups: string[];
  firstName: string;
  lastName: string;
  address: string;
  postalCodeId: string;
  phone: string;
  mobilePhone: string;
  email: string;
  _id: string;
  isOnline: boolean;
  timestamp: Date;
  archived: boolean;
  modules: any;
  o365Id: string;
  isAgent: boolean;
  userAlreadyInFusionAuth: boolean;
  storageLocation: string;
  debug?: boolean;
}
